
    import './styles.scoped.css';
    export default {
  "dropzone": "awsui_dropzone_1fham_1ln2c_177",
  "dropzone-hovered": "awsui_dropzone-hovered_1fham_1ln2c_193"
};
  